import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const BreadcrumbNavigation = ({ customBreadcrumbs = null }) => {
  const location = useLocation();
  
  // Route to breadcrumb mapping
  const routeMap = {
    '/': { label: 'Home', icon: 'Home' },
    '/customer-dashboard': { label: 'Dashboard', icon: 'LayoutDashboard' },
    '/admin-dashboard': { label: 'Admin Dashboard', icon: 'Shield' },
    '/product-catalog': { label: 'Product Catalog', icon: 'Package' },
    '/service-details': { label: 'Service Details', icon: 'Info' },
    '/rfq-request-form': { label: 'Request Quote', icon: 'FileText' },
    '/rfq-management': { label: 'My RFQs', icon: 'FileText' },
    '/rfq-processing': { label: 'RFQ Processing', icon: 'Settings' },
    '/shopping-cart': { label: 'Shopping Cart', icon: 'ShoppingCart' },
    '/order-history': { label: 'Order History', icon: 'History' },
    '/login': { label: 'Login', icon: 'LogIn' },
    '/register': { label: 'Register', icon: 'UserPlus' }
  };

  const generateBreadcrumbs = () => {
    if (customBreadcrumbs) {
      return customBreadcrumbs;
    }

    const pathSegments = location?.pathname?.split('/')?.filter(segment => segment);
    const breadcrumbs = [{ label: 'Home', path: '/', icon: 'Home' }];

    let currentPath = '';
    pathSegments?.forEach((segment, index) => {
      currentPath += `/${segment}`;
      const routeInfo = routeMap?.[currentPath];
      
      if (routeInfo) {
        breadcrumbs?.push({
          label: routeInfo?.label,
          path: currentPath,
          icon: routeInfo?.icon,
          isLast: index === pathSegments?.length - 1
        });
      } else {
        // Fallback for dynamic routes or unmapped paths
        const formattedLabel = segment?.split('-')?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1))?.join(' ');
        
        breadcrumbs?.push({
          label: formattedLabel,
          path: currentPath,
          icon: 'ChevronRight',
          isLast: index === pathSegments?.length - 1
        });
      }
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  // Don't show breadcrumbs on home page or auth pages
  if (location?.pathname === '/' || location?.pathname === '/login' || location?.pathname === '/register') {
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-6" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        {breadcrumbs?.map((crumb, index) => (
          <li key={crumb?.path} className="flex items-center space-x-2">
            {index > 0 && (
              <Icon name="ChevronRight" size={14} className="text-muted-foreground/50" />
            )}
            
            {crumb?.isLast ? (
              <span className="flex items-center space-x-1 text-foreground font-medium">
                <Icon name={crumb?.icon} size={14} />
                <span>{crumb?.label}</span>
              </span>
            ) : (
              <Link
                to={crumb?.path}
                className="flex items-center space-x-1 hover:text-foreground transition-smooth"
              >
                <Icon name={crumb?.icon} size={14} />
                <span>{crumb?.label}</span>
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default BreadcrumbNavigation;